import { render } from "./SortContainer.vue?vue&type=template&id=1d846a34&scoped=true&ts=true"
import script from "./SortContainer.ts?vue&type=script&lang=ts&external"
export * from "./SortContainer.ts?vue&type=script&lang=ts&external"

import "./SortContainer.scss?vue&type=style&index=0&id=1d846a34&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d846a34"]])

export default __exports__